import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import EntityForm from "@/components/probaworkflows_base_components/OnboardingForms/EntityForm/EntityForm.vue";

export default {
  name: 'ApplicationOverview',
  components: {
    NavigationBackButton,
    EntityForm,
  },

  data: () => ({
    application_id: '',
    active_tab: '',
    tabs: [],
    requests: [],
    dropdown_expanded: false,
    steps: [
      { date: "04 Mar", title: "Onboarding", status: "completed" },
      { date: "05 Mar", title: "Manual verification", status: "in-progress" },
      { date: "06 Mar", title: "Auto verification", status: "pending" },
      { date: "06 Mar", title: "Compliance", status: "pending" },
    ],
    form_name: ''

  }),
  mounted() {
    this.application_id = sessionStorage.getItem('application_id');
    this.form_name = sessionStorage.getItem('selected_form_name');
    if (this.form_name) {
      this.tabs = [this.form_name];
      this.active_tab = this.form_name;
    }
  },
  methods: {
    set_active_tab(tab) {
      this.active_tab = tab;
    },

    redirect_to_requested_information() {
      this.$router.push({
        path: '/requested_information_update',
      });
    },

    redirect_to_auto_verification_overview() {
      this.$router.push({
        path: '/auto_verification_overview',
      });
    },
  }
}